<template>
  <div class="col-sm-12 col-md">
    <InputWidget
      id="input-last_name"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import BaseSignupTextInput from "../core/AbstractSignupTextInput";
import AbstractSignupTextInput from "../core/AbstractSignupTextInput";
import BaseInputMixin from "../../../../mixins/signupInputMixin";
import InputWidget from "@/components/core/InputWidget.vue";

export default {
  name: "LastName",
  components: {InputWidget, AbstractSignupTextInput, BaseSignupTextInput},
  mixins: [BaseInputMixin('last_name')],
  props: {
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      defaultLabel: this.$t("Last Name")
    }
  }
}
</script>

<style scoped>

</style>
